import { render, staticRenderFns } from "./TelevisionView.vue?vue&type=template&id=0fd226fa&scoped=true"
import script from "./TelevisionView.vue?vue&type=script&lang=js"
export * from "./TelevisionView.vue?vue&type=script&lang=js"
import style0 from "./TelevisionView.vue?vue&type=style&index=0&id=0fd226fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd226fa",
  null
  
)

export default component.exports